module.exports = __webpack_public_path__ + "img/header_logo.8d0e1feb.png";